import { render, staticRenderFns } from "./FeedbackPortal.vue?vue&type=template&id=26ae06b6&scoped=true"
import script from "./FeedbackPortal.vue?vue&type=script&lang=js"
export * from "./FeedbackPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae06b6",
  null
  
)

export default component.exports